// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Graph Engine API
 * HTTP API for managing Neo4j graph engines.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface HandlersPatchGraphEnginesInternalRequest
 */
export interface HandlersPatchGraphEnginesInternalRequest {
  /**
   *
   * @type {Array<string>}
   * @memberof HandlersPatchGraphEnginesInternalRequest
   */
  ids?: Array<string>;
  /**
   *
   * @type {string}
   * @memberof HandlersPatchGraphEnginesInternalRequest
   */
  memory?: string;
  /**
   *
   * @type {string}
   * @memberof HandlersPatchGraphEnginesInternalRequest
   */
  neo4jVersion?: string;
}

/**
 * Check if a given object implements the HandlersPatchGraphEnginesInternalRequest interface.
 */
export function instanceOfHandlersPatchGraphEnginesInternalRequest(
  value: object,
): value is HandlersPatchGraphEnginesInternalRequest {
  return true;
}

export function HandlersPatchGraphEnginesInternalRequestFromJSON(
  json: any,
): HandlersPatchGraphEnginesInternalRequest {
  return HandlersPatchGraphEnginesInternalRequestFromJSONTyped(json, false);
}

export function HandlersPatchGraphEnginesInternalRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): HandlersPatchGraphEnginesInternalRequest {
  if (json == null) {
    return json;
  }
  return {
    ids: json['ids'] == null ? undefined : json['ids'],
    memory: json['memory'] == null ? undefined : json['memory'],
    neo4jVersion:
      json['neo4jVersion'] == null ? undefined : json['neo4jVersion'],
  };
}

export function HandlersPatchGraphEnginesInternalRequestToJSON(
  json: any,
): HandlersPatchGraphEnginesInternalRequest {
  return HandlersPatchGraphEnginesInternalRequestToJSONTyped(json, false);
}

export function HandlersPatchGraphEnginesInternalRequestToJSONTyped(
  value?: HandlersPatchGraphEnginesInternalRequest | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    ids: value['ids'],
    memory: value['memory'],
    neo4jVersion: value['neo4jVersion'],
  };
}
